<!--
 * @Author: your name
 * @Date: 2021-07-30 09:30:06
 * @LastEditTime: 2021-08-23 11:30:12
 * @LastEditors: Please set LastEditors
 * @Description: 点位标注
 * @FilePath: \contingency-manage\src\views\map\SatelliteMap\pointCompont\CompanyPoint.vue
-->
<template>
  <div class="CompanyPoint mapPoint" ref="mapPointRef">
    <div :class="['pointContent', 'pointStatus' + infoData.status]">
      <div class="pointHead">
        <div class="pointTitle">
          {{ infoData.name }}
        </div>
        <div class="pointIcon" @click="clickPoint">
          <i :class="['iconfont', 'icon-jianzhu']"></i>
        </div>
      </div>
      <div class="pointSpot">
        <div class="spot" :class="'spot' + i" v-for="i in 4" :key="i"></div>
      </div>
      <div class="Ripples"></div>
    </div>
  </div>
</template>
<script >
import { defineComponent, reactive, toRefs, onMounted, ref } from "vue";

// import deviceApi from '@/views/map/SatelliteMap/js/PointApi.js';
import mapApi from "../js/MapApi";
import { useContext } from "@/hooks/core/useContext.js";

export default defineComponent({
  name: "CompanyPoint",
  components: {},
  props: {
    infoData: {
      type: Object,
    },
    drawMethod: {
      type: String,
      default: "openLayer",
    },
  },
  setup(props) {
    const mapPointRef = ref(null);
    const data = reactive({
      popup: "",
      watchType: "companyShowState",
      poiType: "CompanyPoint",
    });
    const refData = toRefs(data);
    const { setData } = useContext("myMapEvent");

    // const { draw, drawImage } = deviceApi(mapPointRef, props, data);
    const { drawImages, myMap } = mapApi();
    const clickPoint = () => {
      setData("companyInfoDialog", true);
    };
    // 点击地图
    const clickMap = () => {
      closeMenu();
    };
    // 关闭菜单
    const closeMenu = () => {
      data.showMenu = false;
    };
    onMounted(() => {
      // if (props.drawMethod === "openLayer") {
      //   draw(mapPointRef, props.infoData);
      // } else if (props.drawMethod === "images") {
      //   drawImage(mapPointRef, props.infoData);
      // }
      console.log(props.infoData, 7777777);
      console.log(myMap, 11111111);
      drawImages(mapPointRef, props, data);
    });
    return {
      ...refData,
      mapPointRef,
      clickMap,
      clickPoint,
    };
  },
});
</script>
<style  lang='scss' scoped >
.mapPoint {
  width: 0px;
  height: 0px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  z-index: 1;
  .pointContent {
    position: absolute;
    bottom: 100%;
    transform: translateX(-50%);
    pointer-events: none;

    $statusColor: (
      ("1", #f80408, #fc5842, #362f12, #e35c03, #fe4963),
      ("2", #ff9240, #fb963c, #38430b, #daa802, #fe6f4d),
      ("3", #dde801, #fbf841, #21471b, #a2df05, #f9ce4b),
      ("4", #0597e0, #3dd5ff, #0a0e3e, #0064e6, #52f9ff)
    );
    @each $i, $color1, $color2, $color3, $color4, $color5 in $statusColor {
      &.pointStatus#{$i} {
        .pointHead {
          .pointTitle {
            border-color: $color1;
            box-shadow: 0 0 10px 3px $color1 inset;
            color: $color1;
          }
          .pointIcon {
            color: $color2;
            @include border-gradient($color3, top, $color4, $color5);
          }
        }
        .pointSpot .spot {
          background-color: $color4;
        }
        .Ripples {
          @include animation-dian;
          background-color: red;
        }
        .Ripples:before {
          animation-delay: 1s;
        }

        .Ripples:after,
        .Ripples:before {
          content: "";
          width: 100%;
          height: 100%;
          background-color: $color4;
          animation-name: myBMapPoint;
          animation-duration: 2s;
          animation-fill-mode: backwards;
          animation-iteration-count: infinite;
          display: inline-block;
          position: absolute;
          top: 0;
          left: 0;
          border-radius: 50%;
        }
        @keyframes myBMapPoint {
          from {
            opacity: 1;
            transform: scale(1);
          }

          to {
            opacity: 0;
            transform: scale(15);
          }
        }
      }
    }
    .pointHead {
      color: #3dd5ff;
      width: 50px;
      height: 50px;
      position: relative;
      pointer-events: auto;
      @include flex-row-c-c;
      .pointTitle {
        $titleColor: #0597e0;
        position: absolute;
        bottom: calc(100% + 10px);
        border: 1px solid $titleColor;
        box-shadow: 0 0 10px 3px $titleColor inset;
        color: $titleColor;
        padding: 10px 15px;
        font-size: 14px;
        white-space: nowrap;
        background-color: rgba($color: #121f3c, $alpha: 0.9);
        border-radius: 5px;
        text-align: center;
        font-weight: 600;
        z-index: 3;
        user-select: none;
        pointer-events: none;
      }
      .pointIcon {
        width: 100%;
        height: 100%;
        @include border-gradient(#0a0e3e, top, #0064e6, #52f9ff);
        text-align: center;
        border-radius: 50%;
        cursor: pointer;
        position: relative;
        z-index: 2;
        @include flex-row-c-c;
        .iconfont {
          font-size: 24px;
        }
      }
    }
    .pointSpot {
      pointer-events: none;
      @include flex-col-c-c;
      .spot {
        border-radius: 50%;
        background-color: #42d2fd;
        margin-top: 5px;
        &.spot4 {
          width: 3px;
          height: 3px;
        }
        &.spot3 {
          width: 5px;
          height: 5px;
        }
        &.spot2 {
          width: 7px;
          height: 7px;
        }
        &.spot1 {
          width: 9px;
          height: 9px;
        }
      }
    }
  }
}
</style>
